import EmojiRatingPage from "@components/EmojiRatingPage"
import { isHomeDesignFlow } from "@helpers/localStorage"

export default function BoldLooksPage() {
  if (isHomeDesignFlow()) {
    return (
      <EmojiRatingPage
        translationKey="boldLooksHomeDesign"
        leftLabelKey="playItSafe"
        rightLabelKey="goForIt"
      />
    )
  }
  return (
    <EmojiRatingPage
      translationKey="boldLooks"
      leftLabelKey="playItSafe"
      rightLabelKey="superBold"
    />
  )
}
